// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-48hour-deposit/form-item-business-48hour-deposit.component.scss
// module id = 838
// module chunks = 0